module.exports = __webpack_public_path__ + "static/cashew_nuts_td_3-d3ab454f4a70878ca87b895609153ea4.jpg";